import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "./SalesTransactionsWithAMLProfile";
import { ButtonBase } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
  Inputs,
  Spinner,
  Tables,
  AutocompleteComponent,
  SelectComponet,
  PermissionsComponent,
} from "../../../Components";
import {
  TableActions,
  TableFilterTypesEnum,
  AMLTransactionStatusEnum,
} from "../../../Enums";
import { returnPropsByPermissions } from "../../../Helper";
import {
  GetAllSaleTransactionsWithAmlAPI,
  lookupItemsGet,
  getProperties,
  GetAllSaleAgentsServices,
  GetAllBranches,
  GetAllDevelopersContactsAPI,
} from "../../../Services";
import { GlobalOrderFilterActions } from "../../../store/GlobalOrderFilter/GlobalOrderFilterActions";
import { ActiveItemActions } from "../../../store/ActiveItem/ActiveItemActions";
import { useTitle } from "../../../Hooks";
import { headerData } from "./HeaderData";
import { SalesTransactionsWithAMLPermissions } from "../../../Permissions";
import { useDebouncedAction } from "../../../Hooks/DebouncedAction";
import LookupAutocomplete from "../../../Components/Controls/LookupAutocomplete/LookupAutocomplete";

const parentTranslationPath = "SalesTransactionsView";
const translationPath = "";

export const SalesTransactionsWithAMLView = () => {
  const searchTimer = useRef(null);
  const { t } = useTranslation(parentTranslationPath);
  useTitle(t(`${translationPath}sales-transactions-with-aml`));
  const [isLoading, setIsLoading] = useState({
    salesTransactions: false,
    properties: false,
    communitie: false,
    saleAgentsAPI: false,
    branch: false,
    allDevelopers: false,
  });

  const [searchInput, setSearchInput] = useState("");
  const AMLTransactionStatusList = useMemo(
    () => [
      ...Object.values(AMLTransactionStatusEnum).filter(
        (s) => s.key !== 1 && s.key !== 2
      ),
    ],
    []
  );
  const [sortBy, setSortBy] = useState(null);

  const [salesTransactions, setSalesTransactions] = useState({
    result: [],
    totalCount: 0,
  });

  const [allItems, setAllItems] = useState({
    allDevelopers: [],
  });
  const orderFilter = useSelector((state) => state.GlobalOrderFilterReducer);
  const dispatch = useDispatch();
  const [selectedOrderBy, setSelectedOrderBy] = useState({
    filterBy:
      (orderFilter.salesTransactionsWithAMLFilter &&
        orderFilter.salesTransactionsWithAMLFilter.filterBy) ||
      null,
    orderBy:
      (orderFilter.salesTransactionsWithAMLFilter &&
        orderFilter.salesTransactionsWithAMLFilter.orderBy) ||
      null,
  });
  const [isClearedAllFiltersClick, setIsClearedAllFiltersClick] =
    useState(false);
  const [properties, setProperties] = useState({ result: [], totalCount: 0 });
  const [communities, setCommunities] = useState({ result: [], totalCount: 0 });
  const [saleAgents, setSaleAgents] = useState({ result: [], totalCount: 0 });
  const [branchList, setBranchList] = useState({
    result: [],
    totalCount: 0,
  });
  const [tableFilterData, setTableFilterData] = useState([]);
  const [orderBy, setOrderBy] = useState(
    selectedOrderBy.filterBy
      ? selectedOrderBy
      : { filterBy: null, orderBy: null }
  );
  const baseActions = useMemo(
    () => getActionTableWithPermissions(),
    [getActionTableWithPermissions]
  );

  const defaultFilter = {
    sellerAgentId: null,
    landLordAgentId: null,
    buyerAgentId: null,
    tenantAgentId: null,
    buyerBranchId: null,
    sellerBranchId: null,
    tenantBranchId: null,
    landlordBranchId: null,
    communityId: null,
    propertyId: null,
    pageIndex: 0,
    pageSize: parseInt(localStorage.getItem("Pagination")) || 25,
    unitRefNumber: null,
    orderBy: null,
    filterBy: "UnitTransactionId",
    statusId: null,
    unitNumber: null,
    buyerName: null,
    sellerName: null,
    sellingPrice: null,
    transactionEntryDate: null,
    unitTransactionId: null,
    tenantName: null,
    landLordName: null,
    rentPerYear: null,
    contractStartDate: null,
    contractEndDate: null,
    contractRent: null,
    propertyName: null,
    communityName: null,
    buyerAgent: null,
    sellerAgent: null,
    buyerBranch: null,
    sellerBranch: null,
    tenantAgent: null,
    tenantBranch: null,
    landlordBranch: null,
    landlordAgent: null,
    tenantStaffId: null,
    landlordStaffId: null,
    buyerStaffId: null,
    sellerStaffId: null,
    transactionStatusId: null,
    sellerTeamManager: null ,
    sellerTeamLead: null ,
    buyerTeamManager: null , 
    buyerTeamLead: null ,
    affiliateIds: null,
  };

  const [filter, setFilter] = useState({ ...defaultFilter });
  const [selected, setSelected] = useState({
    property: null,
    community: null,
    buyerAgent: null,
    sellerAgent: null,
    tanentAgent: null,
    landLordAgent: null,
    buyerBranch: null,
    sellerBranch: null,
    transactionStatus: null,
    developers : [],
    affiliate: []
  });

  const onFilterValuesChanged = (newValue) => {
    const localFilterDto = filter || {};
    if (newValue) {
      Object.values(newValue)
        .filter((item) => item.searchableKey || item.displayPath)
        .map((item) => {
          if (localFilterDto[item.displayPath] || item.value) {
            if (item.displayPath === "status") {
              localFilterDto["statusId"] = item.value;
            } else {
              localFilterDto[item.displayPath] = item.value === '' ?  null  : item.value;            }
          }
          return undefined;
        });
    }
    setFilter(() => ({ ...localFilterDto }));
  };

  function getActionTableWithPermissions() {
    const list = [];
    if (
      returnPropsByPermissions(
        SalesTransactionsWithAMLPermissions.ViewTransactionDetails.permissionsId
      )
    )
      list.push({
        enum: TableActions.openFile.key,
        isDisabled: false,
        externalComponent: null,
      });
    if (
      returnPropsByPermissions(
        SalesTransactionsWithAMLPermissions.EditTransactions.permissionsId
      )
    )
      list.push({
        enum: TableActions.editText.key,
        isDisabled: false,
        externalComponent: null,
      });
    return list;
  }

  const tableActionClicked = useCallback(
    (actionEnum, item, focusedRow, event) => {
      event.stopPropagation();
      event.preventDefault();
      if (actionEnum === TableActions.openFile.key) {
        localStorage.setItem(
          "saleTransactionDetailsId",
          item.saleTransactionDetailsId
        );
        dispatch(ActiveItemActions.activeItemRequest(item));
        window.open
          (
          `/home/sales-transactions-with-AML/transaction-profile?unitId=${item.unitId}&unitTransactionId=${item.unitTransactionId}&actionType=2&propertyId=${item.propertyId}` ,          "_blank"

        );
      } else if (actionEnum === TableActions.editText.key) {
        localStorage.setItem(
          "saleTransactionDetailsId",
          item.saleTransactionDetailsId
        );
        dispatch(ActiveItemActions.activeItemRequest(item));
        window.open(
          `/home/sales-transactions-with-AML/transaction-profile?unitId=${item.unitId}&unitTransactionId=${item.unitTransactionId}&actionType=1` , 
          "_blank"

        );
      }
    },
    []
  );
  const searchHandler = (search) => {
    if (searchTimer.current) clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => {
      setFilter((item) => ({ ...item, pageIndex: 0, unitRefNumber: search }));
    }, 700);
    setSearchInput(search);
  };

  const getAllSalesTransactions = useCallback(useDebouncedAction(async () => {
    if (isLoading?.salesTransactions) return;
    if (isClearedAllFiltersClick) setIsClearedAllFiltersClick(false);
    if (
      returnPropsByPermissions(
        SalesTransactionsWithAMLPermissions.ViewSalesTransactionsWithAML
          .permissionsId
      )
    ) {
      setIsLoading((loading) => ({ ...loading, salesTransactions: true }));
      const res = await GetAllSaleTransactionsWithAmlAPI({
        ...filter,
        pageIndex: filter.pageIndex + 1,
      });
      if (!(res && res.status && res.status !== 200)) {
        setSalesTransactions({
          result: res && res.result,
          totalCount: res && res.totalCount,
        });
      } else {
        setSalesTransactions({
          result: [],
          totalCount: 0,
        });
      }
      setIsLoading((loading) => ({ ...loading, salesTransactions: false }));
    }
  }, { delay: 100 }), [filter]);

  const getBranch = async (branchName) => {
    setIsLoading((loading) => ({ ...loading, branch: true }));

    const res = await GetAllBranches({
      pageSize: 25,
      pageIndex: 1,
      branchName,
    });
    if (!(res && res.status && res.status !== 200)) {
      setBranchList({
        result: res.result,
        totalCount: res.totalCount,
      });
    } else {
      setBranchList({
        result: [],
        totalCount: 0,
      });
    }
    setIsLoading((loading) => ({ ...loading, branch: false }));
  };

  const onPageIndexChanged = (pageIndex) => {
    setFilter((item) => ({ ...item, pageIndex, search: searchInput }));
  };
  const onPageSizeChanged = (pageSize) => {
    setSearchInput("");
    setFilter((item) => ({
      ...item,
      pageIndex: 0,
      pageSize,
      search: "",
    }));
  };
  useEffect(() => {
    getAllSalesTransactions();
  }, [getAllSalesTransactions, filter]);
  useEffect(
    () => () => {
      if (searchTimer.current) clearTimeout(searchTimer.current);
    },
    []
  );

  const GetAllowSalesTransactionDetails = () => {
    // add new Permissions

    return false;
  };
  const filterByChanged = (value) => {
    setSelectedOrderBy((item) => ({ ...item, filterBy: value }));
  };
  const orderByChanged = (value) => {
    setSelectedOrderBy((item) => ({ ...item, orderBy: value }));
  };
  const orderBySubmitted = (event) => {
    event.preventDefault();
    if (!selectedOrderBy.filterBy || !selectedOrderBy.orderBy) {
      if (orderBy.filterBy || orderBy.orderBy) setOrderBy({});
      return;
    }
    dispatch(
      GlobalOrderFilterActions.globalOrderFilterRequest({
        ...orderFilter,
        salesTransactionsWithAMLFilter: {
          filterBy: selectedOrderBy.filterBy,
          orderBy: selectedOrderBy.orderBy,
        },
      })
    );
    setOrderBy({
      filterBy: selectedOrderBy.filterBy,
      orderBy: selectedOrderBy.orderBy,
    });
  };

  const getAllProperties = useCallback(async (searchItem) => {
    setIsLoading((loading) => ({ ...loading, properties: true }));
    const res = await getProperties({
      pageSize: 10,
      pageIndex: 0,
      search: searchItem || "",
    });
    if (!(res && res.status && res.status !== 200)) {
      setProperties({
        result: res && res.result,
        totalCount: res && res.totalCount,
      });
    } else {
      setProperties({
        result: [],
        totalCount: 0,
      });
    }
    setIsLoading((loading) => ({ ...loading, properties: false }));
  }, []);

  const getAllCommunitie = useCallback(async (searchItem) => {
    setIsLoading((loading) => ({ ...loading, communitie: true }));
    const res = await lookupItemsGet({
      pageIndex: 1,
      pageSize: 10,
      lookupTypeId: 19,
      lookupTypeName: "community",
      searchedItem: searchItem || "",
    });

    if (!(res && res.status && res.status !== 200)) {
      setCommunities({
        result: res && res.result,
        totalCount: res && res.totalCount,
      });
    } else {
      setCommunities({
        result: [],
        totalCount: 0,
      });
    }
    setIsLoading((loading) => ({ ...loading, communitie: false }));
  }, []);
  const onClearedAllFiltersClick = useCallback(() => {
    setSelectedOrderBy((item) => ({ ...item, filterBy: null, orderBy: null }));
    setOrderBy({ filterBy: null, orderBy: 2 });
    setFilter({ ...defaultFilter });
    setSelected({
      property: null,
      community: null,
      buyerAgent: null,
      sellerAgent: null,
      tanentAgent: null,
      landLordAgent: null,
      buyerBranch: null,
      sellerBranch: null,
      transactionStatus: null,
      developers : [],
      affiliate: []
    });
    setSearchInput("");
    setIsClearedAllFiltersClick(true);
  });

  const GetAllDevelopers = async (search) => {
    setIsLoading((i) => ({ ...i, allDevelopers: true }));
    let list = [];

    const rs = await GetAllDevelopersContactsAPI({
      pageIndex: 1,
      pageSize: 50,
      search: search,
    });
    if (!(rs && rs.status && rs.status !== 200)) {
      rs.result.map((element) => {
        const developerContact =
          element?.contact && JSON.parse(element.contact);
        list.push({
          developerName: developerContact?.contact?.company_name,
          developerId: element.developerId,
          contactsId: element.contactsId,
        });
      });
    }
    setAllItems((g) => ({ ...g, allDevelopers: list || [] }));
    setIsLoading((i) => ({ ...i, allDevelopers: false }));
  };

  const getAllSaleAgentsAPI = useCallback(async (searchItem) => {
    setIsLoading((loading) => ({ ...loading, saleAgentsAPI: true }));
    const res = await GetAllSaleAgentsServices({
      pageSize: 10,
      pageIndex: 0,
      search: searchItem || "",
    });
    if (!(res && res.status && res.status !== 200)) {
      setSaleAgents({
        result: res && res.result,
        totalCount: res && res.totalCount,
      });
    } else {
      setSaleAgents({
        result: [],
        totalCount: 0,
      });
    }
    setIsLoading((loading) => ({ ...loading, saleAgentsAPI: false }));
  }, []);

  useEffect(() => {
    getAllCommunitie();
    getAllProperties();
    getAllSaleAgentsAPI();
    getBranch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (sortBy)
      setFilter((item) => ({
        ...item,
        filterBy: sortBy.filterBy,
        orderBy: sortBy.orderBy,
      }));
  }, [sortBy]);

  useEffect(() => {
    if (orderBy)
      setFilter((item) => ({
        ...item,
        filterBy: orderBy.filterBy,
        orderBy: orderBy.orderBy,
      }));
  }, [orderBy]);

  useEffect(() => {
    setTableFilterData(
      headerData(t, AMLTransactionStatusList).map((column) => ({
        key: column.key || column.fieldKey || column.id,
        filterType:
          (column.isDate && TableFilterTypesEnum.datePicker.key) ||
          (column.withSelectFilter && TableFilterTypesEnum.selectOption.key) ||
          TableFilterTypesEnum.textInput.key,
        isHiddenFilter: column.isHiddenFilter,
        textInputType: column.textInputType,
        textInputMax: column.textInputMax,
        textInputMin: column.textInputMin,
        displayPath: column.input,
        optionFilterList: column?.optionFilterList,
      }))
    );
  }, []);

  return (
    <div className="view-wrapper">
      <Spinner isActive={isLoading.salesTransactions} />
      <PermissionsComponent
        permissionsList={Object.values(SalesTransactionsWithAMLPermissions)}
        permissionsId={
          SalesTransactionsWithAMLPermissions.ViewSalesTransactionsWithAML
            .permissionsId
        }
      >
        <div className="d-flex-column">
          <div className="header-section">
            <div className="filter-section">
              <div className="section" />
              <div className="section autocomplete-section">
                <div className="d-flex-column px-2 w-100 p-relative">
                  <div className='d-flex w-100'>
                    <Inputs
                      idRef='salesTransactionsSearchRef'
                      value={searchInput}
                      beforeIconClasses='mdi mdi-magnify mdi-24px c-gray-primary'
                      onInputChanged={(e) => {
                        searchHandler(e.target.value);
                      }}
                      inputPlaceholder={'Search Ref No'}
                      translationPath={translationPath}
                      parentTranslationPath={parentTranslationPath}
                    />
                    <LookupAutocomplete
                      placeholder='Affiliate / Sub-Branch'
                      lookupName={'Affiliate/Sub-Branch'}
                      wrapperClasses='w-25 mx-2 mb-2'
                      multiple
                      selectedValues={selected.affiliate}
                      onChange={(_e, newValue) => {
                        const affiliateIds = newValue?.map(
                          (item) => item?.lookupItemId
                        );
                        setFilter((item) => ({
                          ...item,
                          affiliateIds,
                        }));
                        setSelected((item) => ({
                          ...item,
                          affiliate: newValue,
                        }));
                      }}
                    />
                  </div>
                  <div className="d-inline-flex-column pl-4-reversed">
                    <div className="d-flex mb-1">
                      <div className="autocomplete-wrapper mr-1-reversed">
                        <AutocompleteComponent
                          selectedValues={selected.transactionStatus}
                          idRef="transactionStatusId"
                          multiple={false}
                          data={[...AMLTransactionStatusList] || []}
                          displayLabel={(option) =>
                            (option && option.name && t(`${option.name}`)) || ""
                          }
                          withoutSearchButton
                          inputPlaceholder={t(
                            `${translationPath}transaction-status`
                          )}
                          parentTranslationPath={parentTranslationPath}
                          translationPath={translationPath}
                          onChange={(event, newValue) => {
                            setFilter((item) => ({
                              ...item,
                              transactionStatusId:
                                (newValue && newValue.key) || null,
                              pageIndex: 0,
                            }));
                            setSelected((item) => ({
                              ...item,
                              transactionStatus: newValue,
                            }));
                          }}
                        />
                      </div>
                      <div className="autocomplete-wrapper mr-1-reversed">
                        <AutocompleteComponent
                          selectedValues={selected.property || ""}
                          idRef="propertyIdRef"
                          isLoading={isLoading.properties}
                          multiple={false}
                          data={(properties && properties.result) || []}
                          displayLabel={(option) =>
                            option.property?.property_name || ""
                          }
                          withoutSearchButton
                          inputPlaceholder={t(`${translationPath}property`)}
                          parentTranslationPath={parentTranslationPath}
                          translationPath={translationPath}
                          onChange={(event, newValue) => {
                            setFilter((item) => ({
                              ...item,
                              propertyId:
                                (newValue && newValue.propertyId) || null,
                              pageIndex: 0,
                            }));
                            setSelected((item) => ({
                              ...item,
                              property: (newValue && newValue) || "",
                            }));
                          }}
                          onInputKeyUp={(e) => {
                            const { value } = e.target;
                            if (searchTimer.current)
                              clearTimeout(searchTimer.current);
                            searchTimer.current = setTimeout(() => {
                              getAllProperties(value);
                            }, 700);
                          }}
                        />
                      </div>
                      <AutocompleteComponent
                        selectedValues={selected.community}
                        idRef="communityRef"
                        multiple={false}
                        isLoading={isLoading.communitie}
                        data={communities && communities.result}
                        displayLabel={(option) =>
                          (option && option.lookupItemName) || ""
                        }
                        withoutSearchButton
                        parentTranslationPath={parentTranslationPath}
                        translationPath={translationPath}
                        inputPlaceholder={t(`${translationPath}community`)}
                        onChange={(event, newValue) => {
                          setFilter((item) => ({
                            ...item,
                            communityId:
                              (newValue && newValue.lookupItemId) || null,
                            pageIndex: 0,
                          }));
                          setSelected((item) => ({
                            ...item,
                            community: (newValue && newValue) || "",
                          }));
                        }}
                        onInputKeyUp={(e) => {
                          const { value } = e.target;
                          if (searchTimer.current)
                            clearTimeout(searchTimer.current);
                          searchTimer.current = setTimeout(() => {
                            getAllCommunitie(value);
                          }, 700);
                        }}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="autocomplete-wrapper mr-1-reversed">
                        <AutocompleteComponent
                          selectedValues={selected.buyerAgent}
                          idRef="buyerAgentIdRef"
                          multiple={false}
                          isLoading={isLoading.saleAgentsAPI}
                          withoutSearchButton
                          data={(saleAgents && saleAgents.result) || []}
                          chipsLabel={(option) =>
                            (option && option.agentName) || ""
                          }
                          displayLabel={(option) =>
                            (option && option.agentName) || ""
                          }
                          parentTranslationPath={parentTranslationPath}
                          translationPath={translationPath}
                          // withoutSearchButton
                          inputPlaceholder={t(`${translationPath}buyer-agent`)}
                          onChange={(event, newValue) => {
                            setFilter((item) => ({
                              ...item,
                              buyerAgentId:
                                (newValue && newValue.agentId) || null,
                              pageIndex: 0,
                            }));
                            setSelected((item) => ({
                              ...item,
                              buyerAgent: (newValue && newValue) || "",
                            }));
                          }}
                          onInputKeyUp={(e) => {
                            const { value } = e.target;
                            if (searchTimer.current)
                              clearTimeout(searchTimer.current);
                            searchTimer.current = setTimeout(() => {
                              getAllSaleAgentsAPI(value);
                            }, 700);
                          }}
                        />
                      </div>
                      <AutocompleteComponent
                        selectedValues={selected.sellerAgent}
                        idRef="sellerAgentToRef"
                        multiple={false}
                        isLoading={isLoading.saleAgentsAPI}
                        inputPlaceholder={t(`${translationPath}seller-agent`)}
                        data={(saleAgents && saleAgents.result) || []}
                        chipsLabel={(option) =>
                          (option && option.agentName) || ""
                        }
                        displayLabel={(option) =>
                          (option && option.agentName) || ""
                        }
                        withoutSearchButton
                        parentTranslationPath={parentTranslationPath}
                        translationPath={translationPath}
                        onChange={(event, newValue) => {
                          setFilter((item) => ({
                            ...item,
                            sellerAgentId:
                              (newValue && newValue.agentId) || null,
                            pageIndex: 0,
                          }));
                          setSelected((item) => ({
                            ...item,
                            sellerAgent: (newValue && newValue) || "",
                          }));
                        }}
                        onInputKeyUp={(e) => {
                          const { value } = e.target;
                          if (searchTimer.current)
                            clearTimeout(searchTimer.current);
                          searchTimer.current = setTimeout(() => {
                            getAllSaleAgentsAPI(value);
                          }, 700);
                        }}
                      />
                      <AutocompleteComponent
                        selectedValues={selected.buyerBranch}
                        idRef="buyerBranchRef"
                        multiple={false}
                        isLoading={isLoading.saleAgentsAPI}
                        inputPlaceholder={t(`${translationPath}buyer-branch`)}
                        data={branchList.result || []}
                        chipsLabel={(option) =>
                          (option && option.branchName) || ""
                        }
                        displayLabel={(option) =>
                          (option && option.branchName) || ""
                        }
                        withoutSearchButton
                        parentTranslationPath={parentTranslationPath}
                        translationPath={translationPath}
                        onInputKeyUp={(event) => {
                          const { value } = event.target;
                          if (searchTimer.current)
                            clearTimeout(searchTimer.current);
                          searchTimer.current = setTimeout(() => {
                            getBranch(value);
                          }, 700);
                        }}
                        onChange={(event, newValue) => {
                          setFilter((item) => ({
                            ...item,
                            buyerBranchId:
                              (newValue && newValue.branchId) || null,
                          }));
                          setSelected((item) => ({
                            ...item,
                            buyerBranch: (newValue && newValue) || "",
                          }));
                        }}
                      />
                      <AutocompleteComponent
                        selectedValues={selected?.developers || []}
                        idRef="developerRef"
                        className="px-2"
                        multiple
                        withLoader
                        isLoading={isLoading.allDevelopers}
                        inputPlaceholder={t(
                          `${translationPath}developers-name`
                        )}
                        data={allItems.allDevelopers || []}
                        chipsLabel={(option) =>
                          (option && option?.developerName) || ""
                        }
                        displayLabel={(option) =>
                          (option && option?.developerName) || ""
                        }
                        withoutSearchButton
                        parentTranslationPath={parentTranslationPath}
                        translationPath={translationPath}
                        onInputKeyUp={(event) => {
                          const { value } = event.target;
                          if (searchTimer.current)
                            clearTimeout(searchTimer.current);
                          searchTimer.current = setTimeout(() => {
                            GetAllDevelopers(value);
                          }, 700);
                        }}
                        getOptionSelected={(option) =>
                          (selected &&
                            selected.developers &&
                            selected.developers.findIndex(
                              (item) =>
                                item?.developerId === option?.developerId
                            ) !== -1) ||
                          false
                        }
                        filterOptions={(options) => {
                          const isFind = (id) =>
                            selected.developers?.findIndex(
                              (w) => w.developerId === id
                            ) === -1 || false;
                          return options.filter((w) => isFind(w.developerId));
                        }}
                        filterSelectedOptions
                        onChange={(event, newValue) => {
                          setFilter((item) => ({
                            ...item,
                            developerId:
                              (newValue &&
                                newValue.map((item) => item.contactsId)) ||
                              null,
                          }));
                          setSelected((item) => ({
                            ...item,
                            developers: newValue || [],
                          }));
                        }}
                      />
                      <AutocompleteComponent
                        selectedValues={selected.sellerBranch}
                        idRef="sellerBranchRef"
                        multiple={false}
                        isLoading={isLoading.saleAgentsAPI}
                        inputPlaceholder={t(`${translationPath}seller-branch`)}
                        data={branchList.result || []}
                        chipsLabel={(option) =>
                          (option && option.branchName) || ""
                        }
                        displayLabel={(option) =>
                          (option && option.branchName) || ""
                        }
                        withoutSearchButton
                        parentTranslationPath={parentTranslationPath}
                        translationPath={translationPath}
                        onInputKeyUp={(event) => {
                          const { value } = event.target;
                          if (searchTimer.current)
                            clearTimeout(searchTimer.current);
                          searchTimer.current = setTimeout(() => {
                            getBranch(value);
                          }, 700);
                        }}
                        onChange={(event, newValue) => {
                          setFilter((item) => ({
                            ...item,
                            sellerBranchId:
                              (newValue && newValue.branchId) || null,
                          }));
                          setSelected((item) => ({
                            ...item,
                            sellerBranch: (newValue && newValue) || "",
                          }));
                        }}
                      />
                    </div>
                  </div>
                </div>
                <ButtonBase
                  onClick={onClearedAllFiltersClick}
                  id="onClearedAllFiltersref"
                  className="btns theme-solid bg-danger clear-all-btn max-height"
                >
                  <span className="mdi mdi-filter-remove m-1" />
                  {t(`${translationPath}clear-filters`)}
                </ButtonBase>
              </div>
            </div>

            <div className="d-flex px-2">
              <span className="mx-2 mt-1">{t(`${translationPath}select`)}</span>
              <span className="separator-v s-primary s-reverse s-h-25px mt-1" />
              <span className="px-2 d-flex">
                <span className="texts-large mt-1">
                  {t(`${translationPath}order-by`)}:
                </span>
                <div className="px-2">
                  <SelectComponet
                    idRef="filterByRef"
                    data={[
                      {
                        id: "TransactionEntryDate",
                        filterBy: "transaction-date",
                      },
                    ]}
                    value={selectedOrderBy.filterBy}
                    wrapperClasses="mb-3"
                    isRequired
                    onSelectChanged={filterByChanged}
                    emptyItem={{
                      value: null,
                      text: "select-filter-by",
                      isDisabled: false,
                    }}
                    valueInput="id"
                    textInput="filterBy"
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                    translationPathForData={translationPath}
                  />
                </div>
                <div className="px-2">
                  <SelectComponet
                    idRef="orderByRef"
                    data={[
                      { id: 1, orderBy: "ascending" },
                      { id: 2, orderBy: "descending" },
                    ]}
                    emptyItem={{
                      value: null,
                      text: "select-sort-by",
                      isDisabled: false,
                    }}
                    value={selectedOrderBy.orderBy}
                    onSelectChanged={orderByChanged}
                    wrapperClasses="mb-3"
                    isRequired
                    valueInput="id"
                    textInput="orderBy"
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                    translationPathForData={translationPath}
                  />
                </div>
                <div className="mt-1">
                  <ButtonBase
                    className="btns theme-solid"
                    onClick={orderBySubmitted}
                    id="action_apply"
                    disabled={
                      !selectedOrderBy.filterBy || !selectedOrderBy.orderBy
                    }
                  >
                    <span>{t(`${translationPath}apply`)}</span>
                  </ButtonBase>
                </div>
              </span>
            </div>
          </div>

          <div className="w-100 px-3">
            <Tables
              data={salesTransactions.result || []}
              headerData={headerData(t, AMLTransactionStatusList)}
              defaultActions={baseActions}
              onPageIndexChanged={onPageIndexChanged}
              onPageSizeChanged={onPageSizeChanged}
              actionsOptions={{
                onActionClicked: tableActionClicked,
              }}
              onFilterValuesChanged={onFilterValuesChanged}
              filterData={tableFilterData}
              isWithFilter
              FilterDisabledButton
              itemsPerPage={filter.pageSize}
              activePage={filter.pageIndex}
              translationPath={translationPath}
              parentTranslationPath={parentTranslationPath}
              totalItems={salesTransactions.totalCount}
              setSortBy={setSortBy}
              isClearFiltersClicked={isClearedAllFiltersClick}
              setIsClearFiltersClicked={setIsClearedAllFiltersClick}
            />
          </div>
        </div>
      </PermissionsComponent>
    </div>
  );
};
